import './../App.css';
import React, { useState } from 'react';
import { Rating } from '@mui/material';
import PropTypes from 'prop-types';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';

function RatingInput({handleRating, size = 'big'}) {
  const [rating, setRating] = useState(0);
  let iconSize = size === 'small' ? '5rem' : size === 'mid' ? '6rem' : '8rem';

  const customIcons = {
    1: {
      icon: <SentimentVeryDissatisfiedIcon style={{flex:1, width: iconSize, color:"#ba1968"}}/>,
      label: 'Bad',
      colour: '#ba1968'
    },
    2: {
      icon: <SentimentDissatisfiedIcon  style={{flex:1, width: iconSize, color:"#ef79b1"}}/>,
      label: 'Poor',
      colour: '#ef79b1'
    },
    3: {
      icon: <SentimentSatisfiedIcon style={{flex:1, width: iconSize, color:"#e2bf61"}} />,
      label: 'Average',
      colour: '#e2bf61'
    },
    4: {
      icon: <SentimentSatisfiedAltIcon style={{flex:1, width: iconSize, color:"#34d5c9"}} />,
      label: 'Good',
      colour: '#34d5c9'
    },
    5: {
      icon: <SentimentVerySatisfiedIcon style={{flex:1,  width: iconSize, color:"#04b4ab"}}  />,
      label: 'Excellent',
      colour: '#04b4ab'
    },
  };
  
  function IconContainer(props) {
    const { value, ...other } = props;
    return <div style={{flexDirection: 'column', alignItems: 'center', fontSize: '2rem', textAlign: 'center', marginRight: '2rem', marginLeft: '2rem', transform: rating === value ? 'scale(1.2)' : 'scale(1)'}} {...other}>{customIcons[value].icon}<span style={{color: customIcons[value].colour, fontWeight: rating === value ? 'bold' : 'normal'}}>{customIcons[value].label}</span></div>;
  }
  
  IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
  };
  
  return (
        <Rating
            name="gen-rating"
            onChange={(e, val)=> {
              handleRating(val);
              setRating(val);
            }}
            slotProps={{
              icon: {
                component: IconContainer
              }
            }}
            defaultValue={0}
            highlightSelectedOnly
        />
  );
}

export default RatingInput;